import { IonButton, IonInput, IonItem } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NormalText, StrongText, SmallText, Spacer, Title } from '../../components/common';
import Mobiscroll from '../../components/mobiscroll';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { isEmptyObject } from '../../lib/utils';
import Layout from '../../components/layout';
import { withRouter } from 'react-router';
import Loading from '../../components/spinner';
import './index.css';
import api from '../../lib/api';
import { ReactComponent as VoucherID } from '../../assets/images/voucher-id.svg';
import { ReactComponent as VoucherCode } from '../../assets/images/voucher-code.svg';
import { ReactComponent as VoucherExpiry } from '../../assets/images/voucher-expiry.svg';
import BlockSeparator from '../../components/blockSeparator';


class GiftBalance extends Component {
	constructor(props) {
		super(props);
		this.state = {
			voucherId: '',
			voucherCode: '',
			voucherBalance: null,
		};
	}
	componentDidMount() { }
	checkBalance = async () => {
		try {
			const { voucherCode, voucherId } = this.state;
			const voucher = await api.checkGiftVoucherBalance({ voucher_code: voucherCode, voucher_id: voucherId });
			this.setState({ voucherBalance: voucher.data });
		} catch (err) {
			this.setState({ voucherBalance: { error: true } });
		}
	};
	render() {
		const { __ } = this.props;
		const { voucherBalance } = this.state;
		return (
			<Loading transparent>
				<Layout showHamburger headerWithTitle title={__('Check balance')} hideSecondToolbar={true} color="transparent" scrollY={false} backHandler={this.backHandler}>
					<div className="absolute-content scrollable-y">
						<Title className="web-only">{__('Check balance')}</Title>

						<NormalText className="block">{__('If your voucher does not include a security code, please check in-store')}</NormalText>
						<Spacer size={5} />
						<div className="input-field-container">
							<StrongText>{__('Enter voucher ID')}</StrongText>

							<IonItem lines="none" className="input-field-wrapper">
								<IonInput
									onIonInput={(e) => this.setState({ voucherId: e.target.value })}
									type="number"
									inputmode="numeric"
									pattern="[0-9]*"
									value={this.state.voucherId}
									placeholder={__('Voucher ID')}
								></IonInput>
							</IonItem>
						</div>
						<div className="input-field-container">
							<StrongText>{__('Enter security code')}</StrongText>

							<IonItem lines="none" className="input-field-wrapper">
								<IonInput
									onIonInput={(e) => this.setState({ voucherCode: e.target.value })}
									type="text"
									pattern="text"
									inputmode="text"
									value={this.state.voucherCode}
									placeholder={__('Security code')}
								></IonInput>
							</IonItem>
						</div>
						{!isEmptyObject(voucherBalance) && (
							<>
								<div className={`box-content vocher-balance-result ${voucherBalance.error ? 'vocher-balance-result-error' : ''}`}>
									{voucherBalance.error ? (
										<>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 24 24"
												stroke-width="2"
												stroke="currentColor"
												fill="none"
												stroke-linecap="round"
												stroke-linejoin="round"
											>
												<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
												<path d="M15 19h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5"></path>
												<path d="M19 22v.01"></path>
												<path d="M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"></path>
												<path d="M3 7l9 6l9 -6"></path>
											</svg>
											<StrongText>{__('Voucher not found')}</StrongText>
											<Spacer size={1} />
											<SmallText>{__('Please check the details and try again')}</SmallText>
										</>
									) : (
										<>
											<div style={{ width: '100%' }}>
												<div style={{ padding: 'var(--ion-padding)' }} className='gift-balance-summary'>
													<div className="pill">
														{voucherBalance?.status}
													</div>
													<Spacer size={1} />
													<StrongText className="block">{`${Basket.formatPrice(voucherBalance?.points_value / 100)} ${__('eGift Voucher')}`} </StrongText>
													<Spacer size={3} />
													<div>
														<VoucherID />
														<StrongText>{__('Voucher ID:')}</StrongText>
														<NormalText className='label-color'>{voucherBalance?.id}</NormalText>
													</div>
													<Spacer size={1} />
													<div>
														<VoucherCode />
														<StrongText>{__('Security code:')}</StrongText>
														<NormalText className='label-color'>{voucherBalance?.redeem_code}</NormalText>
													</div>
													<Spacer size={1} />
													<div>
														<VoucherExpiry />
														<StrongText>{__('Expiry date:')}</StrongText>
														<NormalText className='label-color'>{moment(voucherBalance?.expiry_date)?.format('Do MMM yyyy')}</NormalText>
													</div>
													<Spacer size={1} />
												</div>

												<BlockSeparator fullWidth />
												<div style={{ padding: 'var(--ion-padding)' }}>
													<StrongText className="block">{__('Remaining balance:')}</StrongText>
													<Spacer size={1} />
													<NormalText className='label-color'>{Basket.formatPrice(voucherBalance?.value_remaining / 100)}</NormalText>
												</div>

											</div>

										</>
									)}
								</div>
								<Spacer size={5} />

							</>
						)}

						<IonButton disabled={this.state.voucherId == '' || this.state.voucherCode == ''} onClick={() => this.checkBalance()} expand="block" color="primary">
							{__('Check balance')}
						</IonButton>
					</div>
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	return {};
};

export default withRouter(withTranslation(connect(stateToProps)(GiftBalance)));
